import React from 'react';
import {useDispatch} from 'react-redux';
import gql from 'graphql-tag';
import {hooks} from 'lib.front';
import {clientLog} from 'src/common/gqlClientes';
import {logVerificar, loadingModal, openMsg} from 'src/redux-app';

const verificarQ = gql`
   {
      verificarCrm {
         codigo
         nombre
         apPaterno
         apMaterno
         usuario
         email
         condicion
         sucursal
         especialidad
      }
   }
`;

export default function useVerificar() {
   // REDUX
   const dispatch = useDispatch();
   //RECUPERAR ESCRITORIO
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      dispatch(logVerificar(data.verificarCrm));
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
      dispatch(logVerificar({}));
      if (process.env.NODE_ENV === 'development') {
      }
   }

   const [verificarCall] = hooks.useApolloLazyQ(
      verificarQ,
      {
         callbackProcesarData,
         callbackLoading,
         callbackError
      },
      {
         client: clientLog
      }
   );
   return verificarCall;
}
